import { getPipelines } from "../queries/getPipelines.pim.js";
export const getPipelineByName = async ({ pipelineName }, { client }) => {
    const pipelines = await getPipelines({ client });
    const pipeline = pipelines.pipeline.getMany.edges?.find((edge) => edge.node.name === pipelineName)?.node;
    if (!pipeline) {
        throw new Error(`Pipeline not found - PipelineName: ${pipelineName}`);
    }
    return pipeline;
};
